import { RequestAccessForm } from '../api/types';

const changeCustomProperty = (variable: string, value: string) => {
    document.documentElement.style.setProperty(variable, value);
};

const getDynamicStyles = (theme: RequestAccessForm) => [
    { customCSSProperty: '--text-color-paragraph', value: theme.textParagraphColor },
    {
        customCSSProperty: '--text-color-heading',
        value: theme.textHeadingColor,
    },
    { customCSSProperty: '--button-background-color', value: theme.buttonBackgroundColor },
    {
        customCSSProperty: '--button-stroke-color',
        value: theme.buttonStrokeColor,
    },
    {
        customCSSProperty: '--button-text-color',
        value: theme.buttonTextColor,
    },
    {
        customCSSProperty: '--page-background-color',
        value: theme.pageBackgroundColor,
    },
    {
        customCSSProperty: '--counter-background-color',
        value: theme.counterBackgroundColor,
    },
];

const applyTheme = (theme: RequestAccessForm) => {
    const dynamicStyles = getDynamicStyles(theme);

    dynamicStyles.forEach((style) => {
        changeCustomProperty(style.customCSSProperty, style.value);
    });
};

export { applyTheme };
